import { CheckCircleIcon } from '@heroicons/react/24/solid';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const ALL_WEEK_DAYS = [
  { id: 1, day: 'lunes', simbolo: 'L' },
  { id: 2, day: 'martes', simbolo: 'M' },
  { id: 3, day: 'miércoles', simbolo: 'M' },
  { id: 4, day: 'jueves', simbolo: 'J' },
  { id: 5, day: 'viernes', simbolo: 'V' },
  { id: 6, day: 'sábado', simbolo: 'S' },
];

/**
 * Muestra la semana (L–S) resaltando los días con clase, como en la tarjeta del curso.
 * @param {Array<{ day: string, simbolo?: string }>|''|undefined|null} days — Días del curso desde API.
 * @param {boolean} [compact=false] — Celdas más pequeñas para tablas.
 * @param {boolean} [showCheck=true] — Muestra la palomita verde en días con clase (p. ej. desactivar en tablas).
 */
export const CourseWeekDaysGrid = ({ days, compact = false, showCheck = true }) => {
  const list = Array.isArray(days) ? days : [];

  return (
    <div
      className={classNames(
        compact
          ? 'grid grid-cols-6 gap-1 w-full min-w-0'
          : 'w-full grid grid-cols-3 md:grid-cols-6 gap-4',
      )}
    >
      {ALL_WEEK_DAYS.map((dayFromAllDays) => {
        const isClassDay = list.length > 0 && list.some((d) => d.day === dayFromAllDays.day);
        return (
          <div
            key={dayFromAllDays.id}
            className={classNames(
              isClassDay
                ? 'bg-gradient-to-br from-indigo-500 to-indigo-600 text-white border-indigo-600 shadow-md'
                : 'bg-slate-100 text-slate-400 border-slate-300',
              compact
                ? 'relative flex items-center justify-center w-8 h-8 rounded-md border-2 font-bold text-xs transition-all duration-300'
                : 'relative flex items-center justify-center w-10 h-10 rounded-lg border-2 font-bold text-sm transition-all duration-300 hover:scale-105',
            )}
          >
            {dayFromAllDays.simbolo}
            {showCheck && isClassDay && (
              <CheckCircleIcon
                className={classNames(
                  'absolute text-emerald-500 bg-white rounded-full shadow-sm',
                  compact ? '-top-1 -right-1 w-4 h-4' : '-top-1.5 -right-1.5 w-5 h-5',
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
